// React Imports 
import React, { Component } from "react";

// Package Imports
import { Image } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import AuthStore from "modules/login/store/AuthStore";
import { deviceType } from 'react-device-detect';

// Project Imports
import PreNeedSelectionModalStore from "../store/PreNeedSelectionModalStore";
import PreNeedForm from './form'
import PreNeedFormController from "./form/controller";
import utils from "./form/utils";
import * as images from "constants/Images";
import * as APITypes from "../../../constants/API";
import fetchNavigationScreen from "../../../utils/fetchNavigationScreen";
import setCookie from "../../../utils/journeyIdCookie/setJourneyId"
import getCookie from "../../../utils/journeyIdCookie/getJourneyId"
// CSS Imports
import "./pre-need-selection-modal.css";
import { BANCA_JOURNEY, BANCA_SAMS_URL, COOKIE_PARA_NAME_FOR_JOURNEY_ID, SAMS_JOURNEY } from "constants/Constants";
import { EXIT_TOOL } from "constants/UserClicksConstant";
import StorageKeys from "constants/StorageKeys";
import getCookieValue from "utils/getCookieValue/getCookieValue";
import axios from "axios";

const PreNeedSelectionModal = observer(
  class PreNeedSelectionModal extends Component {
    constructor(props) {
      super(props);

      this.state = {
        isOpen: false,
        formController: null,
        targetScreen: 'choose-needs',
        newJourney: false,
        refreshValues: false,
      };
    }

    async componentDidMount() {
      let isOpen = false;
      let controller = new PreNeedFormController()
      let journeyData = toJS(AuthStore.journeyData);
      let journeyId = this.props.match.params.journeyId
      controller.setDefaults(journeyData, journeyId);

      if (journeyId === undefined && !AuthStore.isSessionExpired && !getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)) {
        isOpen = true
        // localStorage.setItem(StorageKeys.SUB_CHANNEL_CODE, "");
      }
      this.setState({
        isOpen: isOpen,
        formController: controller
      })
      PreNeedSelectionModalStore.fetchMasterData()
      if (this.state.isOpen) fetchNavigationScreen()
    }
    componentDidUpdate(prevProps, prevState) {
      if (!prevState.isOpen && this.state.isOpen) {
        fetchNavigationScreen()
      }
    }
    showModalPreNeedSelectionModal = () => {
      this.setState({ isOpen: true });
    };

    hideModalPreNeedSelectionModal = () => {
      this.setState({ isOpen: false });
    };

    onProceedClick = async () => {
      let journeyId = await PreNeedSelectionModalStore.onPreNeedProceedBtnClick()
      if (journeyId === undefined) return
      this.hideModalPreNeedSelectionModal()
      //getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID) = journeyId
      this.props.history.push(`/choose-needs`);
    }



    formSuccessHandler = async (responseData) => {
      let journeyId = responseData.data.journey_id
      await AuthStore.fetchAllData(journeyId);
      this.state.formController.$("journey_id").value = journeyId.toString();
      this.hideModalPreNeedSelectionModal()

      //Set journey id in a cookie
      setCookie("journeyId", journeyId)

      this.props.history.push(`/${this.state.targetScreen}`, { refreshValues: this.state.refreshValues })
    }

    formErrorHandler = (responseData) => {
      console.log("Form Error")
    }

    checkJourneyFlow = (formValues) => {
      let journeyData = toJS(AuthStore.journeyData)
      let customerType = formValues.customer_type === "New Customer" ? 1 : 2
      let selectedPage = this.props.match.params.selectedPage

      let userDetails = journeyData.family_details_list && journeyData.family_details_list[0]
      let productsList = journeyData.family_product_details_list
      let termProduct = productsList && productsList.length > 0 && productsList.find(i => i.need_unique_name === "protection_for_my_family")
      let healthProduct = productsList && productsList.length > 0 && productsList.find(i => i.need_unique_name === "protection_for_my_health")

      this.setState({ newJourney: false, targetScreen: selectedPage, refreshValues: false })
      switch (selectedPage) {
        case "choose-needs":
        case "family-details":
        case "customization":
          // case 1 & Case 2 : User changing the journey type and details of the existing customer and/or Staff member
          if (journeyData.journey_details && journeyData.journey_details.journey_type != formValues.journey_type.id || journeyData.journey_details && journeyData.journey_details.customer_type != customerType) {
            this.setState({ newJourney: true, targetScreen: "choose-needs" })
            return
          }

          // Case 3 : User changing the category
          if (journeyData.journey_details && journeyData.journey_details.category !== formValues.category.id) {
            return
          }

          // Check if the product "protection_for_my_family" and it's calculator is selected, if not return
          if (termProduct && !termProduct.is_selected && !termProduct.is_calculator_used) {
            return
          }

          if (journeyData.family_details_list && (userDetails.education !== formValues.education.id || userDetails.occupation !== formValues.occupation.id)) {
            if (termProduct && termProduct.is_selected && termProduct.is_calculator_used) {
              this.setState({ refreshValues: true, targetScreen: "choose-needs" })
              return
            } else if (termProduct && termProduct.is_selected && !termProduct.is_calculator_used) {
              return
            }
          }
          break
        case "solution":
          // case 1 & Case 2 : User changing the journey type and details of the existing customer and/or Staff member
          if (journeyData.journey_details && journeyData.journey_details.journey_type != formValues.journey_type.id || journeyData.journey_details && journeyData.journey_details.customer_type != customerType) {
            this.setState({ newJourney: true, targetScreen: "choose-needs" })
            return
          }
        case "preview-share":
          // case 1 & Case 2 : User changing the journey type and details of the existing customer and/or Staff member
          if (journeyData.journey_details && journeyData.journey_details.journey_type != formValues.journey_type.id || journeyData.journey_details && journeyData.journey_details.customer_type != customerType) {
            this.setState({ newJourney: true, targetScreen: "choose-needs" })
            return
          }

          // Case 3 : User changing the category
          if (journeyData.journey_details && journeyData.journey_details.category !== formValues.category.id) {
            this.setState({ targetScreen: "customization" })
            return
          }

          // Check if the product "protection_for_my_family" and it's calculator is selected, if not return
          if (termProduct && !termProduct.is_selected && !termProduct.is_calculator_used) {
            return
          }

          if (journeyData.family_details_list && (userDetails.education !== formValues.education.id || userDetails.occupation !== formValues.occupation.id)) {
            if (termProduct && termProduct.is_selected && termProduct.is_calculator_used) {
              this.setState({ refreshValues: true, targetScreen: "choose-needs" })
              return
            } else if (termProduct && termProduct.is_selected && !termProduct.is_calculator_used) {
              this.setState({ targetScreen: "customization" })
              return
            }

            if (healthProduct && healthProduct.is_selected) {
              this.setState({ targetScreen: "customization" })
              return
            }
          }
          break
      }
    }

    submitData = () => {
      // if(this.state.formController.$("partner_rm_code").value != " "){
      //   this.state.formController.errors().partner_rm_code = null
      // }
      this.state.formController.validate({ showErrors: true })
        .then(({ isValid }) => {
          // console.log("Form errors are ", this.state.formController.errors())
          // console.log("value " , this.state.formController.values())
          if (isValid) {
            // Determine what user is changing and redirect accordingly
            let formValues = this.state.formController.values()
            let partnerSectionVisible = this.state.formController.$("partner_rm_code").extra.isVisible;
            let showPfaBtn = this.state.formController?.$("pfa_sp_name")?.extra?.showBtn
            let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];
            const requiredFields = ["pfa_sp_code", "pfa_sp_name", "dmrm_name", "dmrm_code", "partner_rm_code", "partner_branch_name"
            ];
            const allFieldsfilled = requiredFields.every(field => formValues[field]);
            if (partnerSectionVisible) {
              if (channel_code === "COA" || channel_code === "CSB") {
                if (allFieldsfilled) {
                  this.checkJourneyFlow(formValues)
                  utils.submitDataToTheSrver(this.state.formController.values(), this.formSuccessHandler, this.formErrorHandler, this.state.newJourney, deviceType === "browser" ? "desktop" : deviceType)
                } else {
                  requiredFields.forEach(field => {
                    utils.checkValue(this.state.formController, field, formValues[field]);
                  });
                }
              } else {
                if (formValues.pfa_sp_code && formValues.partner_rm_code) {
                  this.checkJourneyFlow(formValues)
                  utils.submitDataToTheSrver(this.state.formController.values(), this.formSuccessHandler, this.formErrorHandler, this.state.newJourney, deviceType === "browser" ? "desktop" : deviceType)
                } else if (!formValues.pfa_sp_code || !formValues.pfa_sp_name) {
                if (!formValues.pfa_sp_code ) {
                    this.state.formController.$("pfa_sp_code").invalidate('This field is mandatory')
                  }
                if (!formValues.pfa_sp_name && showPfaBtn ) {
                    this.state.formController.$("pfa_sp_name").invalidate('This field is mandatory')
                  }
                } else if (!formValues.partner_rm_code) {
                  this.state.formController.$("partner_rm_code").invalidate('This field is mandatory')
                }
              }
            } else {
              if (formValues.pfa_sp_code) {
                this.checkJourneyFlow(formValues)
                utils.submitDataToTheSrver(this.state.formController.values(), this.formSuccessHandler, this.formErrorHandler, this.state.newJourney, deviceType === "browser" ? "desktop" : deviceType)
              } else {
                this.state.formController.$("pfa_sp_code").invalidate('This field is mandatory')
                if (!formValues.pfa_sp_name && showPfaBtn) {
                  this.state.formController.$("pfa_sp_name").invalidate('This field is mandatory')
                }
              }
            }

          } else {
            console.log("Form errors are ", this.state.formController.errors())
          }
        });
    }

    backToSamsAndBanca = async () => {
      let samsUrl = await axios.post(APITypes.GET_SAMS_HOME_URL, { journeyId: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID) })
      if (samsUrl?.data?.url) {
        // window.open(samsUrl?.data?.url, "_self");
        window.location.href = samsUrl?.data?.url
      }
    }

    render() {
      let journeyTypeName = toJS(AuthStore.journeyTypeName)
      let sourceFrom = toJS(AuthStore.sourceFrom)
      let source_system = getCookieValue("source")
      return (
        <div className='welcomeScreeenModalDiv d-flex align-items-center'>
          {/* {journeyTypeName !== undefined && (
            <span className='font-size-lg-16 font-weight-light'>
              {journeyTypeName} | New Customer
            </span>
          )} */}
          {/* <a onClick={this.showModalPreNeedSelectionModal} className={`${sourceFrom !== "Distribution_App" ? 'text-white' : 'text-black pr-2'} btn py-0 d-flex flex-row align-items-center`}>
            {sourceFrom !== "Distribution_App" ? 
              <Image width='12' height='24' src={images.EditIcon} alt='back-arrow' /> : 
              <Image width='12' height='24' src={images.EditBlackColorIcon} alt='back-arrow' />} 
            <span className="font-size-lg-12 font-weight-light">Edit1</span>
          </a> */}
          <a
            className='ml-2 text-white btn py-0 d-flex flex-row align-items-center'
            onClick={() => { AuthStore.saveUserClicks(EXIT_TOOL), utils.handleModalExit(this.props) }}
          >
            Exit Tool
          </a>
          {(source_system === BANCA_JOURNEY || source_system === SAMS_JOURNEY) &&
            <a
              className='ml-2 text-white btn py-0 d-flex flex-row align-items-center bg-gray'
              onClick={() => { this.backToSamsAndBanca() }}>
              Back to SAMS
            </a>
          }
          <Modal
            show={this.state.isOpen}
            backdrop="static"
            onHide={this.hideModalPreNeedSelectionModal}
            as='section'
            className='welcomeScreeenModal'
            aria-labelledby='contained-modal-title-vcenter'
            centered
            keyboard={false}
          >
            <ModalBody className='preNeedSelectionModalBody'>
              <section>
                <div className='row preNeedSelectionModalContent'>
                  <div className='modal-hero'>
                    <div className='mr-lg-2 py-lg-4 mt-2 my-lg-3 text-center text-lg-right'>
                      <h1 className='preHeading text-lg-right'>Welcome to</h1>
                      <img src={images.AppLogo} className="appLogo p-2" width={80} />

                      <p className='subHeading text-lg-right d-none d-lg-block'>
                        Customer Engagement and <br /> Quote Generation Tool
                      </p>
                    </div>
                  </div>

                  <PreNeedForm
                    formController={this.state.formController}
                    hideModal={this.hideModalPreNeedSelectionModal}
                    submitData={this.submitData}
                    {...this.props}
                  />

                </div>
              </section>
            </ModalBody>
          </Modal>
        </div>
      );
    }
  }
);

export default PreNeedSelectionModal;
